import { User } from './User';

// Interface para mostrar en listados (con datos del BusinessName)
export interface Society {
    id?: number;
    business_name_id?: number;
    business_name?: string; // Nombre de la razón social
    rut?: string; // RUT de la razón social
    address?: string; // Dirección de la razón social
    country?: string; // País
    first_name_contact?: string;
    last_name_contact?: string;
    second_last_name_contact?: string;
    email_contact?: string; // Email de la razón social
    phone_code_contact?: string; // Código de teléfono de la razón social
    phone_contact?: string; // Teléfono de la razón social
    is_active?: boolean;
}

export interface SocietyFilters {
    society_id?: number | null;
    rut?: string | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export interface SocietyDataForm {
    id?: number;
    business_name_id?: number; // Solo el ID de la razón social
    is_active?: boolean;
}

export const defaultSocietyForm: SocietyDataForm = {
    business_name_id: undefined,
    is_active: true
};

export interface SocietyDocument {
    id?: number;
    name?: string;
    file?: File;
    issue_date?: string;
    expiration_date?: string;
    type?: string;
    document_id?: number;
    is_expire_date_indefinite: boolean;
    society_id: number;
}

export const defaultSocietyDocument: SocietyDocument = {
    is_expire_date_indefinite: true,
    society_id: 0
};
